import Program from "@/model/program/program";
import Page from "@/model/program/page";
import Window from "@/model/program/window";
import Material from "@/model/program/material";
import constant from "@/utils/constant";
import oUtils from "@/utils/utils";
import browserCheck from "@/utils/browserCheck";
import oProgramService from "@/services/program/programService";
import oMaterialService from "@/services/program/materialService";

const state = {
  editorProgram: {
    programWidth: 1920,
    programHeight: 1080,
    autoSnap: true, //是否自动吸附
  }, // 正在编辑的节目
  canvas: {}, //画布大小、画布和实际分辨率比值
  pageList: [], // 所有页面列表
  editorPage: new Page(), // 正在编辑的页面
  editorWindow: new Window(), //正在操作的窗口
  editorSubWindow: {}, //正在编辑的子窗口
  editorMaterial: {}, //当前正在编辑的素材
  editorMaterials: [], //ctrl+click时多选素材
  selectMaterials: [], //拖拽时多选的素材
  /* 当前选择的素材类型，和window里面的windowMode值相同，但需要单独分出来，因为即使当前没有窗口，也可以选择不同类型的素材 */
  materialType: "",
  material: {}, //素材的鼠标拖动对象
  dragTemplate: {}, //模板的鼠标拖动对象
  windowType: "", //窗口的鼠标拖动类型
  windowTypeList: [], // 当前支持素材窗口类型
  showState: 0, //右侧栏状态 1-页面 2-窗口
  characterDoubleClk: false, //文字窗口是否双击
  pageState: "normal", //客流测温页面状态 normal-正常 alarm-告警
  insertProgram: {},
  editScreenType: "first", //正在编辑的屏幕类型（双面屏节目时可能为second）主屏or副屏
  conferenceSignIn: {},
  isMaterialFold: false, // 左侧素材栏是否收起
  isPageListFold: false, // 底部页面列表是否收起
  isWindowFold: false, // 右侧栏是否收起
  scaleValue: 1,
  programScreenAreaInfo: {},
  previewInfo: {}, // 预览信息
  audioData: [],
  audioPopShow: false, //音频管理popover的显示和隐藏
  audioId: "", //当前页的音频ID
  audioArray: [], //每个页面的音频信息
  currPageState: "normal", // 客流测温当前页面选中状态 normal-正常 alarm-告警
  layoutCap: {}, //布局模板能力集
  isDragingWindow: false, // 正在拖动窗口
  fontSheet: "",
  fontNameList: [],
  programRender: {},
  isDragingMaterail: false, // 正在拖动素材
};
const getters = {
  //获取当前页面的所有窗口
  windows(state) {
    let result = [];
    if (state.editorPage && state.editorPage.windowList) {
      result = state.editorPage.windowList; //实时获取当前编辑
    }
    return result;
  },
  //屏幕类型 horizontal-横屏  vertical-竖屏
  sceenType(state) {
    let result = "horizontal";
    if (state.editorProgram.programWidth >= state.editorProgram.programHeight) {
      result = "horizontal";
    } else {
      result = "vertical";
    }
    return result;
  },
  //当前画布的背景样式【图片、颜色】
  canvasBackgroundStyle(state) {
    let editorPage = state.editorPage;
    let backgroundPic = editorPage.backgroundPic;
    let backgroundPicDeleteFlag = editorPage.backgroundPicDeleteFlag;
    let backgroundStyle = {
      "background-color": editorPage.backgroundColor,
      "background-size": "100% 100%",
      "background-repeat": "no-repeat",
    };
    if (backgroundPic && backgroundPic !== -1 && !backgroundPicDeleteFlag) {
      let url = "";
      if (editorPage.backgroundType === "picUrl") {
        url = oMaterialService.getMaterialThumbnail(backgroundPic, "picUrl");
      } else {
        url = oMaterialService.getMaterialThumbnail(
          backgroundPic,
          "picture",
          false
        );
      }
      backgroundStyle["background-image"] = "url(" + url + ")";
      //backgroundStyle["background-image"] = "url(" + oMaterialService.getMaterialThumbnail(backgroundPic, 'picture') + ")";
    } else {
      backgroundStyle["background-image"] = "none";
    }
    return backgroundStyle;
  },

  layout(state) {
    let result = [];
    if (state.editorPage && state.editorPage.layoutWindowList) {
      result = state.editorPage.layoutWindowList; //实时获取当前编辑
    }
    return JSON.parse(JSON.stringify(result));
  },

  hasLayout(state) {
    //屏幕墙现在认为和布局模板类似
    return (
      !!state.editorPage?.layoutWindowList?.length ||
      (state.editorProgram.applicationType === "cascadeProgram" &&
        !state.editorProgram.isSupportCasCadeResizeAndDrag)
    );
  },

  //根据线信息组装区域信息
  layoutArea(state) {
    //获取相关横线、竖线
    const { programHeight, programWidth } = state.editorProgram;
    let rowLine = [{ x: 0, y: 0, w: programWidth }];
    let colLine = [{ x: 0, y: 0, h: programHeight }];
    let layout = state.editorPage.layoutWindowList || [];
    if (!layout.length) {
      return [];
    }
    layout.forEach((item) => {
      if (item.width === 1) {
        colLine.push({ x: item.x, y: item.y, h: item.height });
      }
      if (item.height === 1) {
        rowLine.push({ x: item.x, y: item.y, w: item.width });
      }
    });
    rowLine.push({ x: 0, y: programHeight, w: programWidth });
    colLine.push({ x: programWidth, y: 0, h: programHeight });
    //从小到大排序
    rowLine.sort((a, b) => {
      return a.y - b.y;
    });
    colLine.sort((a, b) => {
      return a.x - b.x;
    });
    let res = [];
    //从左到右，从上到下生成区域信息
    for (let i = 0; i < colLine.length - 1; i++) {
      let smallRow = ""; //记录当前最小行，和下一个大行形成一块区域
      for (let j = 0; j < rowLine.length; j++) {
        const lineItem = colLine[i];
        const rowItem = rowLine[j];
        // const bigRowItem = rowLine[j + 1];
        // 寻找穿过竖线的横线来拼成一个区域
        //第一次符合条件是上面那条
        //第二次符合条件 就可以组成一个区域
        const xFlag =
          lineItem.x === rowItem.x ||
          (lineItem.x > rowItem.x && rowItem.x + rowItem.w > lineItem.x); // 保证横线穿过竖线
        const yFlag =
          rowItem.y === lineItem.y ||
          (rowItem.y > lineItem.y && rowItem.y <= lineItem.y + lineItem.h); //保证横线在竖线范围内
        if (xFlag && yFlag) {
          if (!smallRow) {
            smallRow = rowItem;
          } else {
            let bigLineItem = "";
            //找到竖线右边第一个符合条件的竖线
            // eslint-disable-next-line no-loop-func
            colLine.some((col, index) => {
              if (
                index > i &&
                smallRow.y >= col.y &&
                smallRow.y <= col.y + col.h &&
                rowItem.y >= col.y &&
                rowItem.y <= col.y + col.h
              ) {
                bigLineItem = col;
                return true;
              }
              return false;
            });
            //到这步应该是出错了，这里做个兼容
            if (!bigLineItem) {
              bigLineItem = colLine[i + 1];
            }
            res.push({
              x: lineItem.x,
              y: smallRow.y,
              height: rowItem.y - smallRow.y,
              width: bigLineItem.x - lineItem.x,
              id: res.length,
            });
            smallRow = rowItem;
          }
        }
      }
    }
    return res;
  },
  //被选中窗口样式
  layoutLine(state, getters) {
    let window = getters.layoutArea.find(
      (layout) => layout.id === state.editorPage.layoutActiveId
    );
    if (window) {
      const { programHeight, programWidth } = state.editorProgram;
      const { height: h1, width: w1, x: x1, y: y1 } = window;
      let { height, width, x, y } = getters.canvasWindow(window);
      // arr[0]上右下左四条线的样式
      // arr[1] 分辨率
      return [
        [
          {
            top: `${Math.floor(y)}px`,
            left: `${x}px`,
            width: `${Math.floor(width)}px`,
            dragStyle:
              y1 === 0 ? "" : { left: `${width / 2 - 4}px`, top: `-4px` },
          },
          {
            top: `${y}px`,
            left: `${Math.floor(x + width)}px`,
            height: `${Math.floor(height)}px`,
            dragStyle:
              x1 + w1 === programWidth
                ? ""
                : { left: `-4px`, top: `${height / 2 - 4}px` },
            isH: true,
          },
          {
            top: `${Math.floor(y + height)}px`,
            left: `${x}px`,
            width: `${Math.floor(width)}px`,
            dragStyle:
              y1 + h1 === programHeight
                ? ""
                : { left: `${width / 2 - 4}px`, top: `-4px` },
          },
          {
            top: `${y}px`,
            left: `${Math.floor(x)}px`,
            height: `${Math.floor(height)}px`,
            dragStyle:
              x1 === 0 ? "" : { left: `-4px`, top: `${height / 2 - 4}px` },
            isH: true,
          },
        ],
        {
          top: `${y + height - 22}px`,
          left: `${x}px`,
          width: `${width}px`,
          position: "absolute",
          val: `${Math.round(w1)}*${Math.round(h1)}`,
          smallFz: width < 60,
        },
      ];
    }
  },
  //提示文字样式
  layoutTip(state, getters) {
    const { programHeight, programWidth } = state.editorProgram;
    const isVertical = programHeight > programWidth;
    const Includes = constant.LAYOUT_FREE_WINDOWS;
    let layoutAndWindow = Object.values(state.editorPage.layoutAndWindow);
    //针对游离样式，判断提示字体的显示和隐藏
    state.editorPage.windowList.forEach((window) => {
      const { x, y, height, width } = window;
      const points = [
        { x, y },
        { x: x + width, y },
        { x, y: y + height },
        { x: x + width, y: y + height },
        { x: x + width / 2, y },
        { x: x + width, y: y + height / 2 },
        { x: x + width / 2, y: y + height },
        { x, y: y + height / 2 },
        { x: x + width / 2, y: y + height / 2 },
      ];
      if (
        Includes.includes(window.windowMode) ||
        window.dataType === "character"
      ) {
        getters.layoutArea.forEach((area) => {
          const { height: h1, width: w1, x: x1, y: y1, id } = area;
          points.some((point) => {
            if (
              point.x >= x1 &&
              point.x <= x1 + w1 &&
              point.y >= y1 &&
              point.y <= y1 + h1
            ) {
              layoutAndWindow.push(id);
              return true;
            }
            return false;
          });
        });
      }
    });
    // 粗略判断横向排布多还是竖向排布多
    let rowLine = [],
      colLine = [];
    getters.layout.forEach((item) => {
      if (item.width === 1) {
        colLine.push({ x: item.x, y: item.y, h: item.height });
      }
      if (item.height === 1) {
        rowLine.push({ x: item.x, y: item.y, w: item.width });
      }
    });
    rowLine.push({ x: 0, y: programHeight, w: programWidth });
    colLine.push({ x: programWidth, y: 0, h: programHeight });
    const isCol = colLine.length >= rowLine.length;
    layoutAndWindow = Array.from(new Set([...layoutAndWindow]));
    return getters.layoutArea.map((layout) => {
      let { height, width, x, y } = getters.canvasWindow(layout);
      const style = browserCheck.isIE()
        ? { "writing-mode": isVertical && isCol ? "tb-lr" : "lr-tb" }
        : { "writing-mode": isVertical && isCol ? "tb" : "lr" };
      return {
        left: isVertical ? `${x + width * 0.5 - 10}px` : `${x + 50}px`,
        top: isVertical ? `${y + 50}px` : y + height * 0.5 - 10 + "px",
        height: isVertical ? `${Math.max(0, height - 100)}px` : "20px",
        width: isVertical ? "20px" : `${Math.max(0, width - 100)}px`,
        notShow: layoutAndWindow.includes(layout.id),
        ...style,
      };
    });
  },

  windowsXY(state, getters) {
    let positionArray = [];
    let mywindow = [];
    let xSet = new Set();
    let ySet = new Set();
    const ratio = state.canvas.ratio;
    if (state.editorProgram && state.editorProgram.lineDisplay) {
      const {
        programHeight,
        programWidth,
        applicationType = "",
      } = state.editorProgram;
      let row = 1;
      let col = 1;
      //计算每块画布的x,y,h,w
      if (applicationType === "cascadeProgram") {
        row = state.editorProgram.row;
        col = state.editorProgram.column;
        for (let i = row, j = col; i >= 1 || j >= 1; ) {
          if (i >= 1) {
            positionArray.push({
              y: programHeight * --i,
              x: 0,
              h: programHeight,
              w: programWidth,
            });
          }
          if (j >= 1) {
            positionArray.push({
              y: 0,
              x: programWidth * --j,
              h: programHeight,
              w: programWidth,
            });
          }
        }
      }
      positionArray.push({ x: 0, y: 0, h: programHeight, w: programWidth });

      //处理节目六条线
      positionArray.forEach((position) => {
        const { x, y, h, w } = position;

        xSet.add(Math.round(x));
        xSet.add(Math.round(x + w / 2));
        xSet.add(Math.round(x + w));
        ySet.add(Math.round(y));
        ySet.add(Math.round(y + h / 2));
        ySet.add(Math.round(y + h));
      });
      //不显示节目最外层四条边的对齐红线
      xSet.delete(0);
      ySet.delete(0);
      xSet.delete(Math.max(...Array.from(xSet)));
      ySet.delete(Math.max(...Array.from(ySet)));

      positionArray = [];

      if (state.editorPage && state.editorPage.windowList) {
        state.editorPage.windowList.forEach((window) => {
          let { x, y, height: h, width: w, rotate = 0 } = window;

          if (rotate) {
            // 计算旋转后的坐标
            const arr = getters.calcRotateTranslate(x, y, w, h, rotate, true);
            let left = Math.min(...arr.map((item) => item.x)); // 最左侧的坐标 就是最小的x
            let right = Math.max(...arr.map((item) => item.x));
            let top = Math.abs(Math.max(...arr.map((item) => item.y))); // 最上方的坐标 就是最大的y(方法拿第四象限算的)
            let bottom = Math.abs(Math.min(...arr.map((item) => item.y)));

            x = left;
            y = top;
            w = right - left;
            h = bottom - top;
          }
          if (window.windowId !== state.editorWindow?.windowId) {
            positionArray.push({ x, y, h, w });
          } else if (state.editorWindow?.windowId) {
            //h、w表示距离中心的距离，缩放时按照中心放大，根据这个值*放大倍数，可以重新设置位置
            mywindow = [
              {
                val: x,
                type: "x",
                h: (programHeight * row) / 2 - y,
                w: (programWidth * col) / 2 - x,
                line: "left",
              },
              {
                val: x + w / 2,
                type: "x",
                h: (programHeight * row) / 2 - (y + h / 2),
                w: (programWidth * col) / 2 - (x + w / 2),
                line: "middle",
              },
              {
                val: x + w,
                type: "x",
                h: (programHeight * row) / 2 - (y + h),
                w: (programWidth * col) / 2 - (x + w),
                line: "right",
              },
              {
                val: y,
                type: "y",
                h: (programHeight * row) / 2 - y,
                w: (programWidth * col) / 2 - x,
                line: "top",
              },
              {
                val: y + h / 2,
                type: "y",
                h: (programHeight * row) / 2 - (y + h / 2),
                w: (programWidth * col) / 2 - (x + w / 2),
                line: "middle",
              },
              {
                val: y + h,
                type: "y",
                h: (programHeight * row) / 2 - (y + h),
                w: (programWidth * col) / 2 - (x + w),
                line: "bottom",
              },
            ];
          }
        });
      }
      //处理窗口
      positionArray.forEach((position) => {
        const { x, y, h, w } = position;

        xSet.add(Math.round(x));
        xSet.add(Math.round(x + w / 2));
        xSet.add(Math.round(x + w));
        ySet.add(Math.round(y));
        ySet.add(Math.round(y + h / 2));
        ySet.add(Math.round(y + h));
      });

      const accuracy = Math.ceil(ratio); //精度范围
      //过滤和编辑窗口相同x、y的线
      let tmp = mywindow.filter((win) => {
        let accArray = [];
        const winVal = Math.round(win.val);
        accArray.push(winVal);
        Array.apply(null, { length: accuracy }).forEach((item, index) => {
          accArray.push(winVal - 1 * index);
          accArray.push(winVal + index);
        });
        if (win.type === "x") {
          return accArray.some((val) => xSet.has(val));
        }
        return accArray.some((val) => ySet.has(val));
      });
      //这里除以画布和分辨率的比例
      tmp.forEach((item) => {
        Object.entries(item).forEach(([key, val]) => {
          typeof val === "number" && (item[key] = val / ratio);
        });
      });
      return tmp;
    }
    return [];
  },
  //音频样式
  audioShow(state, getters) {
    if (!state.audioId) {
      return "";
    }
    let mt = 48;
    const { hasLayout } = getters;
    const { programHeight, programWidth } = state.editorProgram;
    let window = getters.layoutArea.find(
      (layout) => layout.id === state.editorPage.layoutActiveId
    );
    if (
      hasLayout &&
      window &&
      window.x + window.width === programWidth &&
      window.y + window.height === programHeight
    ) {
      mt = 60;
    }
    return {
      color: "rgba(0, 0, 0, 0.2)",
      position: "absolute",
      top: "100%",
      left: "100%",
      "margin-left": "-48px",
      "margin-top": `-${mt}px`,
      "z-index": 999,
      "pointer-events": "none",
      "font-size": "15px",
    };
  },

  // 文字滚动窗口限制不超过5个
  rollingDirectionCap(state) {
    const LIMIT = 5;
    const characterWindows =
      state.editorPage?.windowList?.filter((window) => {
        return (
          (window.windowMode === "character" ||
            (window.windowMode === "dataSource" &&
              window.dataType === "character")) &&
          window.rollingDirection
        );
      }) ?? [];
    return characterWindows.length < LIMIT;
  },

  //窗口背景图片
  windowBackgroundStyle: () => (window) => {
    let backgroundStyle = {
      "background-repeat": "no-repeat",
    };
    let backgroundIPC = window.backgroundIPC;
    let backgroundPic = window.backgroundPic;
    let backgroundPicDeleteFlag = window.backgroundPicDeleteFlag;
    // if (backgroundPic > 0 || backgroundIPC) {
    if (backgroundPic || backgroundIPC) {
      backgroundStyle["background-size"] = "100% 100%";
    }
    // 窗口背景图
    if (window.windowMode === "weather" && window.weatherShowType) {
      if (backgroundPic && backgroundPic !== -1 && !backgroundPicDeleteFlag) {
        let url = "";
        if (window.backgroundType === "picUrl") {
          url = oMaterialService.getMaterialThumbnail(backgroundPic, "picUrl");
        } else {
          url = oMaterialService.getMaterialThumbnail(
            backgroundPic,
            "picture",
            false
          );
        }
        backgroundStyle["background-image"] = "url(" + url + ")";
      } else if (window.weatherShowType === "fiveDays") {
        backgroundStyle[
          "background"
        ] = `linear-gradient(to right, rgba(255, 255, 255, 1) 20%, rgb(244, 244, 244) 20%) no-repeat`;
      } else {
        let backTransparent = !_.isUndefined(window.backTransparent)
          ? window.backTransparent
          : 1;
        // let backTransparent = window.backTransparent
        //   ? 1 - parseInt(window.backTransparent, 10) / 100
        //   : 1;
        backgroundStyle["background-color"] = oUtils.getColor(
          window.backgroundColor,
          backTransparent
        );
        backgroundStyle["background-image"] = "none";
      }
    } else if (backgroundIPC) {
      //测温、考勤相机窗口
      // backgroundStyle["background-image"] =
      //   "url(" +
      //   require("@/FocSign/assets/img/ipc/" + backgroundIPC + ".png") +
      //   ")";
    } else if (
      backgroundPic &&
      backgroundPic !== -1 &&
      !backgroundPicDeleteFlag
    ) {
      let url = "";
      if (window.backgroundType === "picUrl") {
        url = oMaterialService.getMaterialThumbnail(
          backgroundPic,
          "picUrl",
          false
        );
      } else {
        url = oMaterialService.getMaterialThumbnail(
          backgroundPic,
          "picture",
          false
        );
      }
      backgroundStyle["background-image"] = "url(" + url + ")";
    } else {
      // 处理背景图删除的问题
      if (["clock", "weather"].includes(window.windowMode)) {
        backgroundStyle["background-image"] = "none";
      }
    }
    return backgroundStyle;
  },

  //当前窗口是否选中
  active: (state) => (window) => {
    return state.editorWindow === window;
  },

  //画布转换后的坐标
  canvasWindow: (state, getters) => (window) => {
    const { hasLayout } = getters;
    const { layoutCap } = state;
    const { resolution, programHeight, programWidth, applicationType } =
      state.editorProgram;
    const coordinate = 1920;
    //当自定义的布局模板的屏幕尺寸大于1920时，将布局模板的最小宽高赋给窗口（窗口的能力集会变大，布局模板的按实际分辨率）
    if (
      hasLayout &&
      resolution === "custom" &&
      // resolution === "selfDefine" &&
      (programHeight > coordinate || programWidth > coordinate) &&
      layoutCap &&
      layoutCap.height &&
      layoutCap.width
    ) {
      window.minWidth = layoutCap.width["@min"];
      window.minHeight = layoutCap.height["@min"];
    }
    let row = 1;
    let col = 1;
    //计算每块画布的x,y,h,w
    if (applicationType === "cascadeProgram") {
      row = state.editorProgram.row;
      col = state.editorProgram.column;
    }
    let ratio = state.canvas.ratio;
    let result = {
      width: parseFloat(window.width / ratio, 2),
      height: parseFloat(window.height / ratio, 2),
      x: parseFloat(window.x / ratio, 2),
      y: parseFloat(window.y / ratio, 2),
      minWidth: parseFloat(window.minWidth / ratio, 2),
      maxWidth: parseFloat(window.maxWidth / ratio, 2),
      minHeight: parseFloat(window.minHeight / ratio, 2),
      maxHeight: parseFloat(window.maxHeight / ratio, 2),
      h: parseFloat(((programHeight * row) / 2 - window.y) / ratio), // 这不是高度！！！！ 是一半高度
      w: parseFloat(((programWidth * col) / 2 - window.x) / ratio),
      // width: window.width / ratio,
      // height: window.height / ratio,
      // x: window.x / ratio,
      // y: window.y / ratio,
      // minWidth: window.minWidth / ratio,
      // maxWidth: window.maxWidth / ratio,
      // minHeight: window.minHeight / ratio,
      // maxHeight: window.maxHeight / ratio
    };
    //console.log("canvasWindow:", result);
    return result;
  },

  // 判断是否支持微动效、圆角、旋转
  isSupportMicroEffect: (state) => (window) => {
    if (
      state.editorProgram.programDeviceType !==
      constant.DEVICE_TYPE.INFORMATION_PUBLISH
    ) {
      return false;
    }
    const supportMicroEffect = ["picture", "character"];
    const nowTypes = [
      ...new Set(
        window?.materialList?.map((material) => material.materialType) ?? []
      ),
    ];
    // 图片、文字支持微动效 混合窗口不支持微动效
    if (
      (((window.windowMode === "character" ||
        (nowTypes.length === 1 && nowTypes[0] === "picture")) &&
        supportMicroEffect.includes(window?.windowMode)) ||
        (window.windowMode === "dataSource" &&
          ["pic", "character"].includes(window?.dataType))) &&
      state.editorProgram.applicationType !== "cascadeProgram"
    ) {
      return true;
    }
    return false;
  },

  //返回字体窗口样式
  fontStyle: (state) => (window, alignType) => {
    let style = {};
    let ratio = state.canvas.ratio;
    switch (
      window.alignType //水平对齐
    ) {
      case "middle":
        style["justify-content"] = "center";
        //style["text-align"] = "center"
        break;
      case "left":
        style["justify-content"] = "flex-start";
        //style["text-align"] = "left"
        break;
      case "right":
        style["justify-content"] = "flex-end";
        //style["text-align"] = "right"
        break;
      default:
        style["justify-content"] = "flex-start";
      //style["text-align"] = "left"
    }
    alignType === "middle" && (style["justify-content"] = "center");
    switch (
      window.verticaAlignType //垂直对齐
    ) {
      case "verticalCenter":
        style["align-items"] = "center";
        break;
      case "top":
        style["align-items"] = "flex-start";
        break;
      case "bottom":
        style["align-items"] = "flex-end";
        break;
      default:
        style["align-items"] = "center";
    }
    switch (
      window.characterStyle //字体类型：加粗
    ) {
      case "bold":
        style["font-weight"] = "bold";
        break;
      case "normal":
        style["font-weight"] = "normal";
        break;
      default:
        style["font-weight"] = "normal";
    }
    // 增加字体样式渲染
    let fontFamily = state.fontNameList.find(
      (res) => res.fontId === window.fontFamily
    );
    style["font-family"] = fontFamily
      ? `${fontFamily.fontName}_${fontFamily.fontId}`
      : "inherit"; // inherit
    // const fontSize = parseInt(window.fontSize / ratio, 10);
    // 保留整数展示容易有误差，所以还是保留小数吧
    const fontSize = window.fontSize / ratio;
    style["font-size"] = fontSize + "px";
    if (fontSize < 12) {
      style["font-size"] = 12 + "px";
      style["zoom"] = fontSize / 12;
    }
    // 行间距 行高处理
    // 行高先固定按1.2倍计算，再根据行间距调整
    let fontSizeShow = fontSize < 12 ? 12 : fontSize;
    // let lineHeight = fontSizeShow * 1.2
    let lineSpace = Math.round(window.fontSize * 0.2);
    // 不同设备有不同的默认行间距，这里先不放开设置，默认按1.2倍字体大小行高处理
    window.lineSpace = 0;
    // window.lineSpace = lineSpace;
    // lineSpace为整数，修正lineHeight
    let lineHeight =
      ((window.fontSize + lineSpace) / ratio / fontSize) * fontSizeShow;
    style["line-height"] = lineHeight + "px";

    style["color"] = window.fontColor;
    let backTransparent = !_.isUndefined(window.backTransparent)
      ? window.backTransparent
      : 1;
    let backgroundColor = oUtils.getColor(
      window.backgroundColor,
      backTransparent
    );
    style["background"] = backgroundColor;
    return style;
  },

  // 获得旋转后的坐标
  windowRotatePosition: () => (x, y, a, b, angle) => {
    angle = angle * (Math.PI / 180);
    // xy(x, y)绕着ab(a, b)旋转angle度后的坐标
    const xDiff = x - a;
    const yDiff = y - b;
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);

    const newX = xDiff * cosAngle - yDiff * sinAngle + a;
    const newY = xDiff * sinAngle + yDiff * cosAngle + b;

    return { x: newX, y: newY };
  },

  // justNeedPoint: true 四个点旋转后的坐标 用第四象限算
  // justNeedPoint: false 旋转后凸出位置和原本位置的差值(最小为0)
  calcRotateTranslate:
    (state, getters) =>
    (x, y, w, h, rotate = 0, justNeedPoint = false) => {
      // 计算矩形中心点的坐标 第四象限来算
      const centerX = x + w / 2;
      const centerY = -y - h / 2;

      //四个角的坐标
      const angle1 = { x: x, y: -y };
      const angle2 = { x: x + w, y: -y };
      const angle3 = { x: x, y: -y - h };
      const angle4 = { x: x + w, y: -y - h };

      // 旋转后四个角坐标
      const positionArr = [
        getters.windowRotatePosition(
          angle1.x,
          angle1.y,
          centerX,
          centerY,
          rotate
        ),
        getters.windowRotatePosition(
          angle2.x,
          angle2.y,
          centerX,
          centerY,
          rotate
        ),
        getters.windowRotatePosition(
          angle3.x,
          angle3.y,
          centerX,
          centerY,
          rotate
        ),
        getters.windowRotatePosition(
          angle4.x,
          angle4.y,
          centerX,
          centerY,
          rotate
        ),
      ];
      if (justNeedPoint) {
        return positionArr;
      }

      // 获取最小的x和y
      const minX = Math.min(...positionArr.map((item) => item.x));
      const minY = -1 * Math.max(...positionArr.map((item) => item.y));

      // drag时判断
      // 旋转后minx在原本的左侧 相当于窗口变大了 所以最大拖动范围要减对应的距离
      // 旋转后minx在原本的右侧 不做处理！！
      const rotateTranslateX = minX > x ? 0 : x - minX;
      const rotateTranslateY = minY > y ? 0 : y - minY;

      return {
        rotateTranslateX,
        rotateTranslateY,
      };
    },

  // 判断旋转后窗口是否超过画布
  isInPage: (state, getters) => (window, angle) => {
    const { programHeight, programWidth } = state.editorProgram;
    let ratio = state.canvas.ratio;

    const w = Math.ceil(programWidth / ratio); // 画布宽
    const h = Math.ceil(programHeight / ratio); // 画布高

    const { x, y, width: w1, height: h1 } = getters.canvasWindow(window); // 窗口x,y,宽,高

    // 判断旋转后的四个角的坐标是否超出画布
    return getters
      .calcRotateTranslate(x, y, w1, h1, angle, true)
      ?.every((point) => {
        point.x = Math.round(point.x);
        point.y = Math.round(point.y);
        return !(point.x < 0 || point.y > 0 || point.x > w || point.y < -h);
      });
  },

  //获取当前三方数据的行数/列数
  dataSourceNum(state) {
    return state.editorWindow.sourceTableDirection === "horizontal"
      ? state.editorWindow.sourceColumn
      : state.editorWindow.sourceRow;
  },

  //当前编辑的行/列
  editSourceLine(state) {
    if (state.editorWindow?.sourceTables) {
      const index = state.editorWindow.sourceTables.findIndex(
        (item) => item.index === state.editorWindow.sourceEditIndex
      );
      return index !== -1 && state.editorWindow.sourceEditIndex !== -1
        ? state.editorWindow.sourceTables[index]
        : {};
    }
    return {};
  },
  // 左侧大类为素材还是模板
  isTemplateType(state) {
    const TEMPLATETYPES = [
      "clock",
      "countdown",
      "weather",
      "dataSource",
      "RSS",
    ]; // 需要展示模板的大类，除非之外展示素材
    return TEMPLATETYPES.includes(state.materialType);
  },
  // 判断是否配置了微动效、圆角、旋转 会和某些操作互斥
  isConfigMicroEffect: () => (window) => {
    return (
      window.AnimationEffectList?.length || window.rotate || window.borderRadius
    );
  },
  // 是否为双面屏节目
  isDoubleProgram(state) {
    return state.editorProgram.programScreenType === "double";
  },

  //获取子窗口
  canvasSubWindow: (state) => (subWindow) => {
    let ratio = state.canvas.ratio;
    const expand = {};
    const obj = ["minWidth", "maxWidth", "minHeight", "maxHeight"];

    obj.forEach((key) => {
      if (subWindow[key] !== undefined) {
        expand[key] = parseFloat(subWindow[key] / ratio, 2);
      }
    });

    return {
      width: parseFloat(subWindow.width / ratio, 10, 2),
      height: parseFloat(subWindow.height / ratio, 10, 2),
      x: parseFloat(subWindow.x / ratio, 10, 2),
      y: parseFloat(subWindow.y / ratio, 10, 2),
      ...expand,
    };
  },

  //时钟等字体大小和颜色
  fontSizeStyle:
    (state) =>
    (window, weatherShowType = "") => {
      console.log("subWindow", window);
      let style = {};
      let ratio = state.canvas.ratio;
      let width =
        window.width * 2 - (window.type === "city" ? window.width * 0.3 : 0);
      /* eslint-disable */
      let length =
        window.content &&
        window.content.replace(/[^\x00-\xff]/g, "rr").length + 1; //字符符长度，中文算两个。 +1因为需要留一点空
      if ("MONTH" === window.content) {
        // 字体不等宽，坑啊
        length += 2;
      }
      /* eslint-enable */
      let fontSize = window.fontSize;
      length > 0 &&
        (fontSize =
          width / length > window.fontSize ? window.fontSize : width / length); //动态计算字体大小，防止超出窗口
      if (weatherShowType) {
        const fontSizeByH =
          Math.floor(
            window.type === "city" && weatherShowType === "today"
              ? Math.floor(window.height / ratio / 2)
              : Math.floor(window.height / ratio) -
                  (window.type === "source" ? 2 : 1)
          ) * ratio;
        fontSize = Math.max(1, Math.min(fontSize - 1, fontSizeByH));
        // 特殊处理openweather的显示
        if (fontSize / ratio < 6 && fontSizeByH > 6) {
          fontSize = fontSizeByH;
        }
        // 记录实际展示的字体大小
        window.fontSizeReal = Math.floor(fontSize);
        // 解决中文谷歌默认最小字体为12显示不了更小的情况
        const minFontSize = 12;
        const supportZoom = browserCheck.getBrowserType() === "chrome";
        if (Math.floor(fontSize / ratio, 10) < minFontSize) {
          const zoom = Math.floor(fontSize / ratio, 10) / minFontSize;
          if (zoom >= 0.9) {
            style["custom-scale"] = 0.9;
          } else if (zoom >= 0.7) {
            style["custom-scale"] = 0.8;
          } else if (zoom >= 0.5) {
            style["custom-scale"] = 0.6;
          } else {
            style["custom-scale"] = Math.max(0.18, zoom);
          }
          supportZoom && (fontSize = minFontSize * ratio);
          // style["transform"] = 'scale(' + zoom + ')';
          // style["transform-origin"] = "top left";
          // fontSize = minFontSize * ratio
        }
      } else {
        // 实际字体大小回显？new add
        const fontSizeReal = Math.max(20, Math.min(400, Math.floor(fontSize)));
        if (fontSizeReal !== window.fontSize) {
          // 修改后不能及时生效，万能的settimeout
          setTimeout(() => {
            window.fontSize = fontSizeReal;
          }, 0);
        }
        // 时钟 解决中文谷歌默认最小字体为12显示不了更小的情况
        const minFontSize = 12;
        if (Math.floor(fontSize / ratio, 10) < minFontSize) {
          const zoom = Math.floor(fontSize / ratio, 10) / minFontSize;
          style["transform"] = "scale(" + zoom + ")";
          style["transform-origin"] = "top left";
          fontSize = minFontSize * ratio;
        }
      }

      style["font-size"] = Math.floor(fontSize / ratio, 10) + "px";
      style["color"] = window.fontColor;
      return style;
    },
};
const mutations = {
  //设置当前编辑节目信息
  SET_EDITOR_PRAGRAM(state, program) {
    state.editorProgram = program;
  },
  //设置画布信息
  SET_CANVAS(state, data) {
    state.canvas = data;
  },
  //新增页面
  ADD_PAGE(state, page) {
    console.log("新增页面page1", page);
    if (typeof page.index === "number" && page.index >= 0) {
      state.pageList.splice(page.index, 0, page.page);
    } else {
      state.pageList.push(page.page);
    }
  },
  //设置为当前编辑页面
  SET_EDITOR_PAGE(state, page) {
    state.editorPage = page || new Page();
    // //修改页面的时候，重新设置当前audioid
    if (state.editorPage.pageId) {
      const double = state.editorProgram.programScreenType === "double";
      state.audioData.some((item) => {
        if (
          item.pageId === state.editorPage.pageId &&
          (!double || item.screenType === state.editScreenType)
        ) {
          state.audioId = item.materialNo;
          return true;
        }
        state.audioId = "";
        return false;
      });
    }
    state.showState =
      state.editorWindow.windowId && state.editorPage.hasEditorWindow ? 2 : 1; //当前页有编辑窗口时显示窗口属性，否则右侧显示页面属性
  },
  //设置缩放比例
  SET_SCALEVALUE(state, scale) {
    state.scaleValue = scale;
  },
  //修改页面
  MODIFY_PAGE(state, pageList) {
    state.pageList = pageList;
    state.editorPage = state.pageList[0] || new Page();
    //修改页面的时候，重新设置当前audioid
    if (state.editorPage.pageId) {
      const double = state.editorProgram.programScreenType === "double";
      state.audioData.some((item) => {
        if (
          item.pageId === state.editorPage.pageId &&
          (!double || item.screenType === state.editScreenType)
        ) {
          state.audioId = item.materialNo;
          return true;
        }
        state.audioId = "";
        return false;
      });
    }
    state.showState = 1;
  },
  //删除页面
  DELETE_PAGE(state, page) {
    let pageList = state.pageList;
    pageList.splice(
      pageList.findIndex((item) => item === page),
      1
    );
    /* 如果删除的是当前正在编辑的page，那么editorPage要重新赋值 */
    if (page === state.editorPage) {
      state.editorPage = state.pageList[0] || new Page(); //设置为第一个页面
    }
  },
  // 复制页面
  COPY_PAGE(state, page) {
    const newPage = { ...JSON.parse(JSON.stringify(page)) };
    state.pageList.push(newPage);
    state.editorPage = newPage;
  },
  //重排页面
  RESET_PAGE(state, pageList) {
    state.pageList = pageList;
  },
  //切换页面时，pageid会改变，对应的audiodata也应该改变
  RESET_AUDIO_DATA(state, data) {
    //传递的是map数据，判断一下
    if (data && data.get) {
      const isDouble = state.editorProgram.programScreenType === "double";
      state.audioData.forEach((audio) => {
        if (
          data.get(audio.pageId) &&
          (!isDouble || audio.screenType === state.editScreenType)
        ) {
          audio.pageId = data.get(audio.pageId);
        }
      });
    }
  },
  // 设置当前编辑的屏幕类型（主屏or副屏）
  SET_EDITOR_SCREEN_TYPE(state, data) {
    state.editScreenType = data;
    //外面主屏辅屏放在modify后，双面屏当前页的播放状态在这里加个判断了
    if (state.editorPage.pageId) {
      const double = state.editorProgram.programScreenType === "double";
      state.audioData.some((item) => {
        if (
          item.pageId === state.editorPage.pageId &&
          (!double || item.screenType === state.editScreenType)
        ) {
          state.audioId = item.materialNo;
          return true;
        }
        state.audioId = "";
        return false;
      });
    }
  },
  // 设置底部页面列表收起状态
  SET_PAGELIST_FOLD(state, data) {
    state.isPageListFold = data;
  },
  SET_PAGELIST_WIDTH(state, data) {
    state.programRender.pageListStyle.width = data;
  },
  // 设置素材折叠状态
  SET_MATERIAL_FOLD(state, data) {
    state.isMaterialFold = data;
    state.programRender.materialSetStyle.isFold = data;
  },
  // 设置素材锁定状态
  SET_MATERIAL_LOCK(state, data) {
    // state.isMaterialLock = data;
    state.programRender.materialSetStyle.isLock =
      !state.programRender.materialSetStyle.isLock;
  },
  // 设置素材类型
  SET_MATERIAL_TYPE(state, data) {
    state.materialType = data;
  },
  //设置全局的音频管理状态
  SET_AUDIO_DATA(state, data) {
    state.audioData = data;
  },
  //设置当前窗口所选的音频数据
  SET_EDITOR_PAGE_AUDIO(state, data) {
    state.audioId = data;
  },
  ENABLED_AUDIO(state) {
    state.editorWindow.enabledAudio = true;
  },
  //设置右侧栏显示什么
  SET_SHOWSTATE(state, data) {
    state.showState = data;
  },
  //设置为当前操作窗口
  SET_EDITOR_WINDOW(state, window) {
    //选中窗口时如果有素材，选中当前窗口展示的素材
    if (
      state.editorWindow !== window &&
      window.materialList &&
      window.materialList.length > 0
    ) {
      let editorSrc = window?.style?.background ?? "";
      let index = window.materialList.findIndex((material) => {
        return (
          editorSrc.indexOf(material.src) !== -1 ||
          (editorSrc?.match(/id=(\d+)/) &&
            +editorSrc?.match(/id=(\d+)/)[1] === +material.materialId)
        );
      });
      // 处理混合窗口，默认素材为窗口素材
      let materialId = window.materialList.findIndex((material) => {
        return material.materialType === window.windowMode;
      });
      state.editorWindow = window || new Window();
      // 统一走设置当前素材逻辑
      // TODO 还不知道为什么点击时钟天气再点击其他窗口window会改变，backgroundPicDeleteFlag 变为false，只能先这样了
      // 加上setTimeout又会导致拖拽天气到素材窗口有背景图的问题，因为窗口变了，还是先不要吧
      // setTimeout(() => {
      //   this.commit('SET_EDITOR_MATERIAL', index === -1
      //     ? window.materialList[materialId === -1 ? 0 : materialId]
      //     : window.materialList[index]);
      // })
      state.editorMaterial =
        index === -1
          ? window.materialList[materialId === -1 ? 0 : materialId]
          : window.materialList[index];
    } else {
      state.editorWindow = window || new Window();
    }

    //标识当前页有编辑的窗口
    if (state.editorPage.pageId) {
      state.pageList.forEach((page) => {
        page.hasEditorWindow = false;
      });
      state.editorPage.hasEditorWindow = true;
    }
    state.editorMaterials = [];
  },
  //添加窗口
  ADD_WINDOW(state, window) {
    state.editorPage.windowList.push(window);
  },
  //点击页面时选中布局模板信息
  SET_ACTIVE_LAYOUT(state, data) {
    const ratio = state.canvas.ratio;
    let { x = -1, y = -1, list = [], windowId, layoutType } = data;
    switch (layoutType) {
      //点击时钟等游离状态时取消布局模板选中
      case "reset":
        state.editorPage.layoutActiveId = -1;
        break;
      //删除窗口时，清除关联关系
      case "del":
        state.editorPage.layoutActiveId = -1;
        try {
          delete state.editorPage.layoutAndWindow[windowId];
        } catch (error) {
          console.log(error);
        }
        break;
      //撤销恢复时，窗口xy就是布局模板的xy，直接根据判断
      case "isXY":
        list.some((window) => {
          if (window.x === x && window.y === y) {
            state.editorPage.layoutActiveId = window.id;
            if (windowId) {
              state.editorPage.layoutAndWindow[windowId] = window.id;
            }
            return true;
          }
          return false;
        });
        break;
      // 针对手动新增的窗口，直接放到第一个没有窗口的布局中
      case "Manual": {
        // 从上往下和id的排列刚好相反，需要排个序
        list = list.sort((a, b) => {
          return a.y - b.y || a.x - b.x;
        });
        let hasId = Object.values(state.editorPage.layoutAndWindow);
        list.some((val) => {
          if (!hasId.includes(val.id)) {
            state.editorPage.layoutActiveId = val.id;
            state.editorPage.layoutAndWindow[windowId] = val.id;
            return true;
          }
          return false;
        });
        break;
      }
      //默认激活相关区域，并建立关系
      default:
        x = x * ratio;
        y = y * ratio;
        list.some((window) => {
          if (
            window.x <= x &&
            window.y <= y &&
            window.x + window.width >= x &&
            window.y + window.height >= y
          ) {
            state.editorPage.layoutActiveId = window.id;
            if (windowId) {
              state.editorPage.layoutAndWindow[windowId] = window.id;
            }
            return true;
          }
          return false;
        });
        break;
    }
    state.editorPage.layoutAndWindow = Object.assign(
      {},
      state.editorPage.layoutAndWindow
    );
  },
  SET_LAYOUT_AND_WINDOW(state, data = {}) {
    state.editorPage.layoutAndWindow = data;
  },
  PROGRAM_RENDER_INIT(state, data) {
    state.programRender = data;
  },
  //设置字体窗口是否已双击
  SET_CHARACTERDOUBLECLK(state, data) {
    state.characterDoubleClk = data;
  },
  //对窗口的操作记录下来
  ADD_STEP(state, data) {
    state.editorPage.backStack = JSON.parse(
      JSON.stringify(stackAdd(state, data))
    );
  },
  //后退按钮按下后，可后退的栈顶pop()，可前进的栈push()
  SET_FORWARD_STACK(state) {
    const window = state.editorPage.backStack.pop();
    state.editorPage.backStack = JSON.parse(
      JSON.stringify(state.editorPage.backStack)
    );
    state.editorPage.forwardStack = [...state.editorPage.forwardStack, window];
  },
  //前进按钮按下后
  SET_BACK_STACK(state) {
    const window = state.editorPage.forwardStack.pop();
    state.editorPage.forwardStack = JSON.parse(
      JSON.stringify(state.editorPage.forwardStack)
    );
    state.editorPage.backStack = [...state.editorPage.backStack, window];
  },
  //重新设置位置
  SET_WINDOW_OLD_POSITION(state, data) {
    const { windowId, x, y, oldX, oldY, old, subName } = data;
    state.editorPage.windowList.some((window) => {
      if (windowId !== undefined && window.windowId === windowId) {
        //处理子窗口逻辑
        if (subName && window.subWindows && window.subWindows.length) {
          window.subWindows.some((sub) => {
            if (sub.name === subName) {
              if (old) {
                sub.x = oldX;
                sub.y = oldY;
              } else {
                sub.x = x;
                sub.y = y;
              }
              return true;
            }
            return false;
          });
        }
        //处理窗口逻辑
        if (!subName) {
          if (old) {
            window.x = oldX;
            window.y = oldY;
          } else {
            window.x = x;
            window.y = y;
          }
          return true;
        }
      }
      return false;
    });
  },
  //布局模板重新设置位置
  SET_LAYOUT_OLD_POSITION(state, data) {
    let { old, list } = data;
    if (old) {
      state.editorPage.layoutWindowList = list.map((layout) => {
        return {
          ...layout,
          height: layout.defH,
          width: layout.defW,
          x: layout.defX,
          y: layout.defY,
        };
      });
    } else {
      state.editorPage.layoutWindowList = list.map((layout) => {
        return {
          ...layout,
          defH: layout.height,
          defW: layout.width,
          defX: layout.x,
          defY: layout.y,
        };
      });
    }
    state.editorPage.layoutActiveId = -1;
  },

  //重新改变大小
  SET_WINDOW_OLD_SIZE(state, data) {
    const {
      windowId,
      height,
      width,
      oldH,
      oldW,
      x,
      y,
      oldX,
      oldY,
      old,
      subName,
      isFull,
    } = data;
    state.editorPage.windowList.some((window) => {
      if (window.windowId === windowId) {
        //处理子窗口逻辑
        if (subName && window.subWindows && window.subWindows.length) {
          window.subWindows.some((sub) => {
            if (sub.name === subName) {
              if (old) {
                sub.height = oldH;
                sub.width = oldW;

                //等大小改变后再修改位置，否则不生效
                //没找到原因，后续优化
                // setTimeout(() => {
                sub.x = oldX;
                sub.y = oldY;
                // }, 10);
              } else {
                sub.height = height;
                sub.width = width;
                sub.x = x;
                sub.y = y;
              }
              return true;
            }
            return false;
          });
        } else if (!subName) {
          if (old) {
            window.height = oldH;
            window.width = oldW;
            // setTimeout(() => {
            window.x = oldX;
            window.y = oldY;
            // }, 10);
          } else {
            window.height = height;
            window.width = width;
            window.x = x;
            window.y = y;
          }
        }

        //不是对子窗口的操作，但是有子窗口，需要对子窗口进行重新赋值
        if (
          !subName &&
          window.subWindows &&
          window.subWindows.length &&
          ["clock", "weather", "countdown", "RSS"].includes(window.windowMode)
        ) {
          let ratioX = width / oldW;
          let ratioY = height / oldH;

          // setTimeout(() => {
          //修改子窗口大小
          let subWindows = window.subWindows;
          for (let item of subWindows) {
            if (isFull) {
              item.width = Number.parseFloat(item.width * ratioX, 2);
              item.height = Number.parseFloat(item.height * ratioY, 2);
              // setTimeout(() => {
              item.x = Number.parseFloat(item.x * ratioX, 2);
              item.y = Number.parseFloat(item.y * ratioY, 2);
              // }, 10);
              item.fontSize = Number.parseFloat(item.fontSize * ratioY, 2);
            } else {
              item.width = Number.parseFloat(item.width / ratioX, 2);
              item.height = Number.parseFloat(item.height / ratioY, 2);
              item.x = Number.parseFloat(item.x / ratioX, 2);
              item.y = Number.parseFloat(item.y / ratioY, 2);
              item.fontSize = Number.parseFloat(item.fontSize / ratioY, 2);
            }
          }
          // }, 20);
        }
        return true;
      }
      return false;
    });
  },
  //更新栈顶的记录
  SWITCH_STEP(state, data) {
    const len = state.editorPage.backStack.length;
    if (len) {
      //没数据说明是获取当前最新window的替换backStack的栈顶
      if (!data) {
        const windowId =
          state.editorPage.backStack[state.editorPage.backStack.length - 1]
            .windowId;
        //新增的window回退时，保持最新的状态
        state.editorPage.windowList.forEach((item) => {
          if (item.windowId === windowId) {
            let newWindow = JSON.parse(JSON.stringify(item));
            newWindow.type = "ADD";
            state.editorPage.backStack.splice(len - 1, 1, newWindow);
          }
        });
      } else {
        //双击放大 ===> resize
        const {
          height: oldH,
          width: oldW,
          x: oldX,
          y: oldY,
          windowId,
        } = state.editorPage.backStack[len - 1];
        const { height, width, x, y, type } = data;
        if (
          Math.round(oldH) !== Math.round(height) ||
          Math.round(oldW) !== Math.round(width) ||
          Math.round(oldX) !== Math.round(x) ||
          Math.round(oldY) !== Math.round(y)
        ) {
          state.editorPage.backStack[len - 1] = {
            oldH,
            oldW,
            oldX,
            oldY,
            type,
            height,
            width,
            x,
            y,
            windowId,
          };
        } else {
          state.editorPage.backStack.pop();
        }
      }
    }
  },

  // 对窗口列表做操作
  SET_WINDOW_LIST(state, list = []) {
    state.editorPage.windowList = list;
    state.showState = 1;
  },
  //window对象设置撤销恢复的通用方法
  SET_WINDOW_CHANGE(state, payload) {
    const {
      windowId,
      oldValue,
      newValue,
      fieldName,
      old = false,
    } = payload || {};
    state.editorPage.windowList.some((window) => {
      if (window.windowId === windowId) {
        if (fieldName === "all") {
          const obj = old ? oldValue : newValue;
          Object.keys(window).forEach((item) => {
            window[item] = obj[item] || window[item];
          });
          return true;
        }
        old ? (window[fieldName] = oldValue) : (window[fieldName] = newValue);
        return true;
      }
      return false;
    });
  },

  // 设置窗口拖动
  SET_WINDOW_DRAGING(state, flag) {
    state.isDragingWindow = flag;
  },

  //设置选中子窗口
  SET_EDITOR_SUBWINDOW(state, subWindow) {
    state.editorSubWindow = subWindow;
  },

  //布局模板能力集赋值
  SET_LAYOUT_CAP(state, data) {
    let { height, width } = data;
    // const {programWidth, programHeight} = state.editorProgram;
    // if (typeof height === 'number') {
    //   // const nowH = state.layoutCap.notFirst ? state.layoutCap['height']['@min'] : state.layoutCap['height']['@min'] / 1920 * programHeight;
    //   // const nowW = state.layoutCap.notFirst ? state.layoutCap['width']['@min'] : state.layoutCap['width']['@min'] / 1920 * programWidth;
    //   state.layoutCap['height']['@min'] = Math.max(state.layoutCap['height']['@min'], height);
    //   state.layoutCap['width']['@min'] = Math.max(state.layoutCap['width']['@min'], width);
    //   // state.layoutCap.notFirst = true;
    // } else {
    state.layoutCap = { height, width };
    // }
  },
  //布局模板清空标红信息
  CLEAR_ALL_LAYOUT_ACTIVE(state) {
    state.pageList.forEach((page) => {
      page.layoutActiveId = -1;
    });
  },
  SET_WINDOW_TYPE_LIST(state, payload) {
    state.windowTypeList = payload.slice();
  },
  //开窗或追加素材时所选择的多素材
  SET_SELECT_MATERIALS(state, data) {
    state.selectMaterials = [];
    if (Array.isArray(data)) {
      state.selectMaterials = data;
    }
  },
  //设置素材选中时鼠标偏移值（用于拖拽素材生成窗口）
  SET_MATERIAL(state, data) {
    state.material = data;
  },
  //设置拖动添加窗口类型
  SET_WINDOW_TYPE(state, type) {
    state.windowType = type;
  },
  //删除窗口
  DELETE_WINDOW(state, window) {
    let windowList = state.editorPage.windowList;
    const index = windowList.findIndex((item) => item === window);
    index + 1 && windowList.splice(index, 1);
    state.showState = 1; //右侧显示页面属性

    //记录删除操作
    state.editorPage.backStack = JSON.parse(
      JSON.stringify(stackAdd(state, { ...window, type: "DEL" }))
    );
  },
  //没有记录的删除窗口操作
  DELETE_WINDOW_NO_SET(state, window) {
    let windowList = state.editorPage.windowList;
    windowList.splice(
      windowList.findIndex((item) => item.windowId === window.windowId),
      1
    );
    state.showState = 1; //右侧显示页面属性
  },
  //添加素材
  ADD_MATERIAL(state, material) {
    state.editorWindow.materialList.push(material);
  },
  //设置为当前编辑的素材
  SET_EDITOR_MATERIAL(state, material) {
    if (material && JSON.stringify(material) !== "{}") {
      const isAutoFill = material.scaleType; //是否开启等比例缩放
      // background还要用来做选中素材的判断，还得设置
      // TODO 后续可以考虑用index标识窗口选中素材
      state.editorWindow.style = {
        // "background-image": "url(" + material.src + ")",
        // "background-repeat": "no-repeat",
        background: "url(" + material.src + ") no-repeat",
        // "background-size": "100% 100%" //是否开启等比例缩放
      };
      state.editorWindow.backgroundPicDeleteFlag = material.materialDeleteFlag;
      if (material.materialDeleteFlag) {
        // 不设置none不会清除之前的背景
        state.editorWindow.style["background-image"] = "none";
      }
      if (!isAutoFill) {
        state.editorWindow.style["background-size"] = "100% 100%";
      } else {
        state.editorWindow.style["background-size"] = `contain`;
        state.editorWindow.style["background-position"] = "center";
        //   //计算图片大下
        //   let img = new Image();
        //   img.src = material.src;
        //   if (img.complete) {
        //     const {height: imgH, width: imgW} = img;
        //     const {height, width} = state.editorWindow;
        //     const ratio = state.canvas.ratio;
        //     material.height = imgH;
        //     material.width = imgW;

        //     let scale = 1;
        //     //比较当前窗口大小和图片大小
        //     scale = Math.max(Number.parseFloat(imgH / height * ratio), Number.parseFloat(imgW / width * ratio));

        //     if (scale > 1) {
        //       state.editorWindow.style["background-size"] = `${ imgW / scale }px ${ imgH / scale }px`;
        //     }
        //     state.editorWindow.style["background-position"] = "center";
        //   }
      }

      if (state.editorWindow.windowMode === "audio") {
        //区分音频是否有素材，加底色
        state.editorWindow.style["background-color"] =
          "rgba(146,141,241, 0.12)";
      }
    }
    state.editorMaterial = material;
  },
  //删除素材
  DELETE_MATERIAL(state, data) {
    const multipleMaterials = !!data?.multipleMaterials;
    let materialList = state.editorWindow.materialList;
    let type = state.editorWindow.windowMode;
    if (multipleMaterials) {
      const editorMaterials = state.editorMaterials.map(
        (material) => material.index
      );
      state.editorWindow.materialList = materialList.filter(
        (material) => !editorMaterials.includes(material.index)
      );
      materialList = state.editorWindow.materialList;
      state.editorMaterials = [];
    } else {
      materialList.splice(
        materialList.findIndex((item) => item === state.editorMaterial),
        1
      );
    }
    if (materialList.length) {
      state.editorMaterial = materialList[0];
      if (
        !materialList[0] &&
        !["weather", "clock", "call", "countdown", "character"].includes(type)
      ) {
        //如果没有素材则修改样式
        try {
          state.editorWindow.style = {};
          state.editorWindow.defaultStyle = {
            background:
              "url(" +
              require("@/assets/image/program/" + type + ".png") +
              ") no-repeat center center",
            "background-size": "48px 48px",
          };
        } catch (e) {
          //
        }
      } else {
        this.commit("SET_EDITOR_MATERIAL", materialList[0]);
        // state.editorWindow.style = {
        //   // "background-image": "url(" + materialList[0].src + ")",
        //   // "background-repeat": "no-repeat",
        //   background: "url(" + materialList[0].src + ") no-repeat",
        //   // "background-size": "100% 100%"
        // };
        // const isAutoFill = state.editorMaterial.scaleType; //是否开启等比例缩放
        // if (!isAutoFill) {
        //   state.editorWindow.style["background-size"] = "100% 100%";
        // } else {
        //   state.editorWindow.style["background-size"] = `contain`;
        //   state.editorWindow.style["background-position"] = "center";
        // }
      }
    } else {
      state.editorWindow.style = {};
      // 没有素材时也要清除状态
      // TODO 看看要不要直接删除窗口
      state.editorWindow.backgroundPicDeleteFlag = false;
      state.editorWindow.defaultStyle = {
        background:
          "url(" +
          require("@/assets/image/program/" + type + ".png") +
          ") no-repeat center center",
        "background-size": "48px 48px",
      };
    }
  },
  //清除所有素材
  DELETE_MATERIAL_ALL(state) {
    let materialList = state.editorWindow.materialList;
    let type = state.editorWindow.windowMode;
    materialList.length = 0;
    try {
      state.editorWindow.style = {};
      state.editorWindow.defaultStyle = {
        background:
          "url(" +
          require("@/assets/image/program/" + type + ".png") +
          ") no-repeat center center",
        "background-size": "48px 48px",
      };
    } catch (e) {
      //
    }
  },

  //设置窗口是否等比例缩放的样式
  SET_NEW_BACKGROUND_SIZE(state) {
    const isAutoFill = state.editorMaterial.scaleType; //是否开启等比例缩放
    if (!isAutoFill) {
      state.editorWindow.style["background-size"] = "100% 100%";
    } else {
      state.editorWindow.style["background-size"] = `contain`;
      state.editorWindow.style["background-position"] = "center";
    }
    state.editorWindow.style = JSON.parse(
      JSON.stringify(state.editorWindow.style)
    );
  },

  // 用于拖拽模板生成窗口或更改模板
  SET_DRAGTEMPLATE(state, data) {
    state.dragTemplate = data;
  },

  //保存时截图将图片换成第一张，并且替换svg的图片为png
  RESET_MATERIAL(state) {
    state.editorPage.windowList.forEach((window) => {
      const cache = JSON.parse(JSON.stringify(window?.style?.background ?? {}));

      if (window?.style?.background && window.materialList?.length > 1) {
        const firstMaterialType = window.materialList[0]?.materialType || "";
        window.windowMode = firstMaterialType || window.windowMode; // 设置为第一个素材的
        const firstMaterialSrc = window.materialList[0]?.src || "";
        // 显示默认素材图片的素材
        if (firstMaterialSrc.includes("data:image/svg")) {
          try {
            const type =
              firstMaterialType === "realStream" ? "IPC" : firstMaterialType;
            window.style.background =
              "url(" +
              require("@/assets/image/program/" + type + ".png") +
              ")" +
              "no-repeat";
            window.style["background-repeat"] = "no-repeat";
            window.style["background-size"] = "48px 48px !important";
            window.style["background-position"] = "center";
          } catch (error) {
            window.style.background = cache;
          }
        } else {
          try {
            window.style.background =
              "url(" + firstMaterialSrc + ")" + "no-repeat";
            const isAutoFill = window.materialList[0].scaleType; //是否开启等比例缩放
            if (!isAutoFill) {
              window.style["background-size"] = "100% 100%";
            } else {
              window.style["background-size"] = `contain`;
              window.style["background-position"] = "center";
            }
          } catch (error) {
            window.style.background = cache;
          }
        }
      }
    });
  },

  // 修改模板
  CHANGE_TEMPLATE(state, page) {
    const { pageId, pageName } = state.editorPage;
    const newPage = new Page({
      ...JSON.parse(JSON.stringify(page)),
      pageId,
      pageName,
    });
    const index = state.pageList.findIndex((page) => page === state.editorPage);
    if (index + 1) {
      state.pageList.splice(index, 1, newPage);
      state.editorPage = newPage;
    }
    // state.pageList.push(newPage);
    // state.editorPage = newPage;
  },
  //布局模板拖拽时，联动其他区域线变化
  SIT_NEW_LAYOUT_POSITION(state, position) {
    const ratio = state.canvas.ratio;
    state.editorPage.layoutWindowList.forEach((item) => {
      const flag =
        item.defY === position.y ||
        (item.height === 1 &&
          item.y >= position.y &&
          item.y <= position.y + position.h); //横线在竖线的范围内
      const flag1 =
        item.defX === position.x ||
        (item.width === 1 &&
          item.x >= position.x &&
          item.x <= position.x + position.w); //竖线在横线的范围内
      // |- 这个样子联动
      //当x相等，且横线在竖线的范围内. 保证竖线左右移动时，横线的位置和高度要变化
      if (item.defX === position.x && flag) {
        item.x = item.defX - position.deltaX * ratio;
        if (!item.isAll && item.height === 1) {
          item.width = item.defW + position.deltaX * ratio;
        }
      } else if (item.defX + item.defW === position.x && flag) {
        // -| 这个样子联动
        // 只需改变宽度
        item.width = item.defW - position.deltaX * ratio;
      }
      //当y相等，且竖线在横线的范围内，保证横线上下移动时，竖线的位置和高度也变化
      if (item.defY === position.y && flag1) {
        // ---
        //  | 这样子联动
        item.y = item.defY - position.deltaY * ratio; //高度变化赋值
        if (!item.isAll && item.width === 1) {
          item.height = item.defH + position.deltaY * ratio;
        }
      } else if (item.defY + item.defH === position.y && flag1) {
        //  |
        // --- 这样子联动
        item.height = item.defH - position.deltaY * ratio;
      }
    });
  },
  //布局模板拖拽结束，赋值
  SET_LAYOUT_DEFPOSION(state) {
    const len = state.editorPage.layoutWindowList.length;
    for (let i = 0; i < len; i++) {
      state.editorPage.layoutWindowList[i].defH =
        state.editorPage.layoutWindowList[i].height;
      state.editorPage.layoutWindowList[i].defW =
        state.editorPage.layoutWindowList[i].width;
      state.editorPage.layoutWindowList[i].defX =
        state.editorPage.layoutWindowList[i].x;
      state.editorPage.layoutWindowList[i].defY =
        state.editorPage.layoutWindowList[i].y;
    }
  },

  // 设置预览全屏状态
  SET_PREVIEW_FULL_SCREEN(state, data) {
    state.previewInfo = data;
  },

  // 设置素材拖动
  SET_MATERIAL_DRAGING(state, flag) {
    state.isDragingMaterail = flag;
  },
};
const actions = {
  //创建\修改节目
  setProgram({ commit }, options) {
    let program = new Program(options);
    commit("SET_EDITOR_PRAGRAM", program);
  },

  //设置当前编辑页
  setCurPage({ commit }, page) {
    commit("SET_EDITOR_PAGE", page);
  },

  //新建页面
  addPage({ commit }, option) {
    let index = option.addIndex; // 新增的顺序，若无则默认添加在末尾
    let page = new Page(option);
    commit("ADD_PAGE", { page, index });
    commit("SET_EDITOR_PAGE", page); //设置当前编辑页
  },

  deletePage({ commit, state }, page) {
    let pageList = state.pageList;
    pageList.splice(
      pageList.findIndex((item) => item === page),
      1
    );
    /* 如果删除的是当前正在编辑的page，那么editorPage要重新赋值 */
    if (page === state.editorPage) {
      commit("SET_EDITOR_PAGE", state.pageList[0] || new Page());
      // state.editorPage = state.pageList[0] || new Page(); //设置为第一个页面
    }
    const index = state.audioData.findIndex(
      (item) => item.pageId == page.pageId
    );
    if (index > -1) {
      state.audioData.splice(index, 1);
    }
  },

  COPY_PAGE({ commit }, oldpage) {
    commit("COPY_PAGE", oldpage);
    // 拷贝音频
    // setTimeout(() => {
    //   if (state.audioData.find(audio => audio.pageId === oldpage.oldPageId)) {
    //     const audioId = state.audioData.find(audio => audio.pageId === oldpage.oldPageId).materialNo;
    //     state.audioData.forEach((item) => {
    //       if (item.pageId === state.editorPage.pageId) {
    //         item.materialNo = audioId;
    //         state.audioId = audioId;
    //       }
    //     });
    //   }
    // }, 100);
  },

  //新建窗口
  addWindow({ commit }, option) {
    let window = new Window(option);
    commit("ADD_WINDOW", window);
    commit("SET_EDITOR_WINDOW", window); //设置当前编辑窗口
    if (window.showState === 2) {
      commit("SET_SHOWSTATE", 2);
    } else {
      commit("SET_SHOWSTATE", 1);
    }
    if (option.type === "DELANDADD") {
      commit("SWITCH_STEP", { type: "RESIZE", ...window }); //特殊处理双击放大的情况
    } else {
      commit("ADD_STEP", { type: "ADD", ...window }); //记录相关操作
    }
    return window;
  },

  //选中窗口
  selectWindow({ commit }, window) {
    commit("SET_EDITOR_WINDOW", window);
    // if (window.showState === 3) { //右侧显示什么。 模板和素材不再区分。去掉3
    //   commit(types.SET_SHOWSTATE, 3);
    // } else
    if (window.showState === 2) {
      commit("SET_SHOWSTATE", 2);
    } else {
      commit("SET_SHOWSTATE", 1);
    }
  },

  addMaterial({ commit }, option) {
    let material = new Material(option);
    commit("ADD_MATERIAL", material);
    if (
      option.setMaterialBackGround === undefined ||
      option.setMaterialBackGround
    ) {
      commit("SET_EDITOR_MATERIAL", material);
    }
  },

  changeStep({ commit, state, getters }, { type }) {
    //后退操作，执行栈顶的相反操作
    if (type === "BACK" && state.editorPage.backStack.length) {
      // if (state.editorPage.forwardStack.length && state.editorPage.forwardStack[state.editorPage.forwardStack.length - 1].type === 'NONE') {
      //   state.editorPage.forwardStack.pop();
      // }
      // state.editorPage.backStep++;
      let window =
        state.editorPage.backStack[state.editorPage.backStack.length - 1];
      window = JSON.parse(JSON.stringify(window)); //深拷贝对象，保证数据之间不会受影响
      // const len = state.editorPage.backStack.length;

      const { type: optType } = window;
      switch (optType) {
        case "ADD":
          //新增的window回退时，保持最新的状态
          // state.editorPage.windowList.forEach(item => {
          //   if (len && item.windowId === window.windowId) {
          //     let newWindow = JSON.parse(JSON.stringify(item));
          //     newWindow.type = "ADD";
          //     state.editorPage.backStack.splice(len - 1, 1, newWindow);
          //   }
          // });
          commit("SWITCH_STEP");
          window.type = "ADD";
          commit("DELETE_WINDOW_NO_SET", window); //不记录操作的删除操作
          state.editorPage?.layoutWindowList?.length &&
            commit("SET_ACTIVE_LAYOUT", { ...window, layoutType: "del" }); //布局模板删除
          break;
        case "DEL":
          commit("ADD_WINDOW", window);
          commit("SET_EDITOR_WINDOW", window); //设置当前编辑窗口
          commit("SET_SHOWSTATE", 2); //显示窗口属性
          window.materialList?.length &&
            window.materialList[0] &&
            commit("SET_EDITOR_MATERIAL", window.materialList[0]); //默认选中第一个素材
          state.editorPage?.layoutWindowList?.length &&
            commit("SET_ACTIVE_LAYOUT", {
              ...window,
              list: getters.layoutArea,
              layoutType: "isXY",
            }); //建立关系
          break;
        case "DEL_ALL":
          commit("SET_WINDOW_LIST", window.list);
          commit("SET_LAYOUT_AND_WINDOW", window.layoutAndWindow);
          break;
        case "DRAG":
          commit("SET_WINDOW_OLD_POSITION", { old: true, ...window });
          break;
        case "RESIZE":
          commit("SET_WINDOW_OLD_SIZE", { old: true, ...window });
          break;
        case "LAYOUT_DRAG":
          commit("SET_LAYOUT_OLD_POSITION", { old: true, ...window });
          break;
        case "SET_WINDOW_CHANGE":
          if (!window.fieldName) {
            console.error("must need fieldName to operation");
          }
          commit("SET_WINDOW_CHANGE", { old: true, ...window });
          break;
        default:
          break;
      }
      commit("SET_FORWARD_STACK");
    } else if (type === "FORWARD" && state.editorPage.forwardStack.length) {
      // --state.editorPage.backStep;
      const len = state.editorPage.forwardStack.length - 1;
      let window = state.editorPage.forwardStack[len];
      window = JSON.parse(JSON.stringify(window));
      // const len = window.materialList.length;
      const { type: optType } = window;
      switch (optType) {
        case "ADD":
          commit("ADD_WINDOW", window);
          commit("SET_EDITOR_WINDOW", window); //设置当前编辑窗口
          commit("SET_SHOWSTATE", 2); //显示窗口属性
          window.materialList?.length &&
            window.materialList[0] &&
            commit("SET_EDITOR_MATERIAL", window.materialList[0]); //默认选中第一个素材
          state.editorPage?.layoutWindowList?.length &&
            commit("SET_ACTIVE_LAYOUT", {
              ...window,
              list: getters.layoutArea,
              layoutType: "isXY",
            }); //建立关系
          break;
        case "DEL":
          commit("DELETE_WINDOW_NO_SET", window);
          state.editorPage?.layoutWindowList?.length &&
            commit("SET_ACTIVE_LAYOUT", { ...window, layoutType: "del" }); //布局模板删除
          break;
        case "DEL_ALL":
          commit("SET_WINDOW_LIST", []);
          commit("SET_LAYOUT_AND_WINDOW", {});
          break;
        case "DRAG":
          commit("SET_WINDOW_OLD_POSITION", window);
          break;
        case "RESIZE":
          commit("SET_WINDOW_OLD_SIZE", { isFull: true, ...window });
          break;
        case "LAYOUT_DRAG":
          commit("SET_LAYOUT_OLD_POSITION", { ...window });
          break;
        case "SET_WINDOW_CHANGE":
          commit("SET_WINDOW_CHANGE", { ...window });
          break;
        default:
          break;
      }
      //两个栈元素互换
      commit("SET_BACK_STACK");
      //判断是否前进到最前面
      // if (state.editorPage.backStack.length && state.editorPage.backStep <= 0 && state.editorPage.forwardStack.length && state.editorPage.forwardStack[state.editorPage.forwardStack.length - 1].type !== 'NONE') {
      //   state.editorPage.forwardStack.push({type: "NONE"});
      // }
    }

    console.log(state.editorPage.backStack);
    console.log(state.editorPage.forwardStack);
  },

  SET_LAYOUT_DEFPOSION({ commit, state }) {
    commit("ADD_STEP", {
      type: "LAYOUT_DRAG",
      list: state.editorPage.layoutWindowList,
    }); //记录相关操作
    commit("SET_LAYOUT_DEFPOSION"); //拖动结束赋值
  },
};

const MAX_STEP = 9;
function stackAdd(state, data) {
  //双击放大有个坑，会触发drag事件，这里做个判断
  // if (len && state.editorPage.backStack[len - 1].forbidFlag) {
  //   state.editorPage.backStack[len - 1].forbidFlag = false;
  //   return state.editorPage.backStack;
  // }
  state.editorPage.backStack.push(data);
  const len = state.editorPage.backStack?.length;
  //操作了一步后，删除本来可以前进的
  if (state.editorPage.forwardStack.length) {
    state.editorPage.forwardStack = [];
  }
  // if (state.editorPage.forwardStack.length && state.editorPage.forwardStack[state.editorPage.forwardStack.length - 1].type !== 'NONE') {
  //   state.editorPage.forwardStack.push({type: "NONE"});
  // }
  //超过最大保存步骤的时候，去除栈底（模拟栈，正常栈结构不应该有这种操作~）
  if (len > MAX_STEP) {
    state.editorPage.backStack.splice(0, 1);
  }
  return state.editorPage.backStack;
}

export default {
  state,
  getters,
  mutations,
  actions,
};
